import type { ImgHTMLAttributes } from "react";
import { CHATBOT_ASSETS } from "../../config/chatbot.config";
import "./AssistantIcon.scss";

export type AssistantIconProps = Omit<
  ImgHTMLAttributes<HTMLImageElement>,
  "src" | "alt" | "decoding"
> & {
  width: number;
  height: number;
};

export function AssistantIcon({
  width,
  height,
  className,
  ...rest
}: AssistantIconProps) {
  return (
    <span
      className={
        className ? `assistant-icon-plate ${className}` : "assistant-icon-plate"
      }
      style={{ width, height }}
      aria-hidden
    >
      <picture>
        <source type="image/webp" srcSet={CHATBOT_ASSETS.assistantIconWebp} />
        <img
          src={CHATBOT_ASSETS.assistantIconPng}
          alt=""
          className="assistant-icon-plate__img"
          decoding="async"
          {...rest}
        />
      </picture>
    </span>
  );
}
